import { authRootSaga } from "@modules/auth/sagas"
import { uiRootSaga } from "@modules/ui/sagas"

export const sagas = [authRootSaga, uiRootSaga]
